import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MxConstansService {
  constructor() {}

  static get(code: MxConstans): any {
    switch (code) {
      case MxConstans.LOCAL_STORAGE_PREFIX:
        return 'si';
      case MxConstans.PASSWORD_MIN_LENGTH:
        return 8;
      case MxConstans.ICON_INFO:
        return 'fa fa-info-circle fa-fw';
      case MxConstans.ICON_SUCCESS:
        return 'fa fa-check-circle fa-fw';
      case MxConstans.ICON_ERROR:
        return 'fa fa-times-circle fa-fw';
      case MxConstans.ICON_WARN:
        return 'fa fa-exclamation-triangle fa-fw';
      default:
        return undefined;
    }
  }
}

export enum MxConstans {
  LOCAL_STORAGE_PREFIX = 10,
  PASSWORD_MIN_LENGTH = 20,
  ICON_INFO = 30,
  ICON_SUCCESS = 40,
  ICON_ERROR = 50,
  ICON_WARN = 60,
}
